import * as React from "react";
import { useEffect } from "react";

import { GlobalLoader } from "../../components/Loader";

import useGetAccountId from "../../customHooks/useGetAccountId";
import useInitialPath from "../../customHooks/useInitialPath";

const AppRedirect = () => {
  const { accountId, IsCustomerManagement } = useGetAccountId();
  const { optionalRedirect } = useInitialPath();

  // Once per account, not on every render: each call sends its own network-only invitation check.
  useEffect(() => {
    optionalRedirect({ accountId, IsCustomerManagement }, true);
  }, [accountId, IsCustomerManagement]);

  return <GlobalLoader />;
};

export default AppRedirect;
